import { render } from "./PasswordRequestEmail.vue?vue&type=template&id=55afc60e&scoped=true&ts=true"
import script from "./PasswordRequestEmail.vue?vue&type=script&lang=ts"
export * from "./PasswordRequestEmail.vue?vue&type=script&lang=ts"

import "./PasswordRequestEmail.vue?vue&type=style&index=0&id=55afc60e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55afc60e"]])

export default __exports__